export default "__VITE_ASSET__ZaXmfTln__"